import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["url"];
import quickFetch from 'quick-fetch';
import { getAssociationPreviews } from '../utils/crmUtils';
import { OBJECT_TYPE } from 'marketing-platform-lib/constants/crm';
const GUID_REGEX = /^([0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12})$/;
export function getFilterGroups(objectId, objectTypeId) {
  const objectIdFilter = {
    operator: 'EQ',
    property: 'hs_object_id',
    value: String(objectId)
  };
  const originAssetIdFilter = {
    operator: 'EQ',
    property: 'hs_origin_asset_id',
    value: String(objectId)
  };
  const contentIdFilter = {
    operator: 'EQ',
    property: 'hs_content_id',
    value: String(objectId)
  };
  // Converts fully qualified name to object type id
  const resolvedObjectTypeId = OBJECT_TYPE[objectTypeId] || objectTypeId;

  /**
   * Assets that can also be filtered by hs_origin_asset_id:
   *  - [0-25] LANDING_PAGE: so we can fetch the full Landing page object from CMS BE
   *  - [0-38] SITE_PAGE: so we can fetch the full Site page object from CMS BE
   *  - [0-39] BLOG_POST: so we can fetch the full Blog Post object from CMS BE
   *  - [0-71] SOCIAL_BROADCAST: temporary filter condition until it is fully on the CRM.
   */
  if (resolvedObjectTypeId === OBJECT_TYPE.LANDING_PAGE || resolvedObjectTypeId === OBJECT_TYPE.SITE_PAGE || resolvedObjectTypeId === OBJECT_TYPE.BLOG_POST || resolvedObjectTypeId === OBJECT_TYPE.SOCIAL_BROADCAST) {
    return [{
      filters: [objectIdFilter]
    }, {
      filters: [originAssetIdFilter]
    }];
  }

  /**
   * Asset that needs to be filtered by hs_content_id:
   *  - [0-10] CONTENT: so we can fetch the full Content object from CMS BE
   */
  if (resolvedObjectTypeId === OBJECT_TYPE.CONTENT) {
    return [{
      filters: [objectIdFilter]
    }, {
      filters: [contentIdFilter]
    }];
  }

  /**
   * If fetching CAMPAIGN (0-35) and @objectId is in guid format, query using hs_origin_asset_id only
   */
  if (resolvedObjectTypeId === OBJECT_TYPE.CAMPAIGN && GUID_REGEX.test(String(objectId))) {
    return [{
      filters: [originAssetIdFilter]
    }];
  }
  return [{
    filters: [objectIdFilter]
  }];
}
export function makeCrmObjectSearchRequestName({
  objectTypeId,
  objectId
}) {
  return `fetch-crm-object-${objectTypeId}-${objectId}`;
}
export function makeCrmObjectInboundDbRequestName({
  objectTypeId,
  objectId
}) {
  return `fetch-crm-object-inbounddb-${objectTypeId}-${objectId}`;
}
export function quickFetchCrmObject(objectId, objectTypeId, crmProperty) {
  let filterGroups = getFilterGroups(objectId, objectTypeId);
  // Backwards compatibility for the `crmProperty` parameter
  if (crmProperty) {
    filterGroups = [{
      filters: [{
        operator: 'EQ',
        property: crmProperty,
        value: objectId
      }]
    }];
  }
  quickFetch.makeEarlyRequest(makeCrmObjectSearchRequestName({
    objectTypeId,
    objectId
  }), {
    url: quickFetch.getApiUrl('/crm-search/search', true),
    data: JSON.stringify({
      count: 1,
      filterGroups,
      objectTypeId,
      offset: 0,
      query: '',
      requestOptions: {
        allPropertiesFetchMode: 'latest_version',
        includeAllProperties: true
      },
      sorts: [],
      associationPreviews: getAssociationPreviews(objectTypeId)
    }),
    timeout: 15000,
    dataType: 'json',
    contentType: 'application/json',
    type: 'POST'
  });
  if (!crmProperty || crmProperty === 'hs_object_id') {
    quickFetch.makeEarlyRequest(makeCrmObjectInboundDbRequestName({
      objectTypeId,
      objectId
    }), {
      url: quickFetch.getApiUrl(`/inbounddb-objects/v1/crm-objects/${objectTypeId}/${objectId}?includeAllValues=true`, true),
      dataType: 'json',
      timeout: 15000,
      type: 'GET'
    });
  }
}
export function makeCrmObjectsEarlyRequestName({
  objectTypeId
}) {
  return `fetch-crm-objects-${objectTypeId}`;
}
export function quickFetchCrmObjects(searchOptions, ajaxOptions) {
  const _ref = ajaxOptions || {},
    {
      url = '/crm-search/search'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  quickFetch.makeEarlyRequest(makeCrmObjectsEarlyRequestName({
    objectTypeId: searchOptions.objectTypeId
  }), Object.assign({
    url: quickFetch.getApiUrl(url, true),
    data: JSON.stringify(searchOptions),
    timeout: 15000,
    dataType: 'json',
    contentType: 'application/json',
    type: 'POST'
  }, rest));
}